import script from "./CMPSelectorPeriodo.vue?vue&type=script&setup=true&lang=js"
export * from "./CMPSelectorPeriodo.vue?vue&type=script&setup=true&lang=js"

import "./CMPSelectorPeriodo.vue?vue&type=style&index=0&id=b98d1dae&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b98d1dae"]])

export default __exports__